import { render, staticRenderFns } from "./ReturnProcessing.vue?vue&type=template&id=af5e04f0"
import script from "./ReturnProcessing.vue?vue&type=script&lang=js"
export * from "./ReturnProcessing.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports